import cn from 'classnames';
import { forwardRef } from 'react';
import type { UseControllerProps } from 'react-hook-form';

type TTextArea = JSX.IntrinsicElements['textarea'];

export interface FormTextArea
  extends Omit<TTextArea, 'name'>,
    Pick<UseControllerProps, 'name'> {}

export const ResizeableTextArea = forwardRef<HTMLTextAreaElement, FormTextArea>(
  ({ className, name, value, ...props }, ref) => (
    <div
      className={cn(
        'grid w-full after:invisible after:col-start-1 after:row-start-1 after:w-full after:min-w-[1em] after:whitespace-pre-wrap after:content-[attr(data-value)]',
        className,
      )}
      data-value={value}
    >
      <textarea
        {...props}
        ref={ref}
        className={cn(
          'col-start-1 row-start-1 w-full cursor-text resize-none text-gray-800 shadow-none outline-none transition duration-200 placeholder:text-gray-500 disabled:cursor-not-allowed disabled:text-gray-500',
          className,
        )}
        name={name}
        rows={1}
        value={value}
      />
    </div>
  ),
);
